import { Store } from "react-notifications-component";

const MAX_NOTIFICATIONS = 3;

let activeNotificationIds: string[] = [];

export const notification = (
  title: string,
  message: string,
  type: "success" | "danger" | "info" | "default" | "warning"
) => {
  if (activeNotificationIds.length >= MAX_NOTIFICATIONS) {
    const notificationsToRemove = activeNotificationIds.slice(0, activeNotificationIds.length - MAX_NOTIFICATIONS + 1);
    notificationsToRemove.forEach((notificationId: string) => {
      Store.removeNotification(notificationId);
      activeNotificationIds = activeNotificationIds.filter(id => id !== notificationId);
    });
  }

  const notificationId = Store.addNotification({
    title: title,
    message: message,
    type: type,
    insert: "top",
    container: "top-right",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeIn"],
    dismiss: {
      duration: 3000,
      onScreen: true,
      showIcon: true,
      touch: true,
    },
  });

  if (notificationId) {
    activeNotificationIds.push(notificationId);
  }
};
